import { Channel as IChannel } from "@/websocket/model/channel";
import { Channel } from "@/websocket/model/messages/channel";
import { ChannelType } from "@/websocket/model/enums/channel-type";

// Prepend number of zeros (0) calculated based on required overall length
export const normalizeLength = (number: number | string, length?: number) => {
    // What if 'number' will be longer than required 'length'? Shouldn't happen but what if?
    const str = String(number);
    return "0".repeat((length || 4) - str.length) + str;
};

export const channelsToMessage = (channels: IChannel[]) => {
    return channels.map((i) => new Channel(i.type, i.id).toString()).join("");
};

export const newChannel = (type: ChannelType, id: number) => {
    return new Channel(type, id);
};

export const newChannels = (type: ChannelType, ids: number[]) => {
    return ids.map((id) => newChannel(type, id));
};
